import {defineCustomElement} from 'custom-extensions/ui-utils';
import GenesisModal from './lib/GenesisModal';

export {
	GenesisModal
};

defineCustomElement('g-modal', GenesisModal);
